import { livenessErrors } from '@interco/inter-frontend-liveness-lib'

export interface SerasaSdkError {
  code?: string | number
  detail?: string
}

const BFF_SDK_LOAD_ERROR_CODE = livenessErrors.SERASA_EXPERIAN_IDF_LOAD_SCRIPT_ERROR.code

export const shouldFallbackToEnvSerasaSdk = (
  error: SerasaSdkError | undefined,
  alreadyUsingEnvSdk: boolean,
): boolean => {
  if (alreadyUsingEnvSdk || error?.code == null) return false

  return String(error.code) === String(BFF_SDK_LOAD_ERROR_CODE)
}
